import React from 'react';
import { View, Text } from 'react-native';
import theme from '../../../theme';
import Button from '../Button';

export default function AgentsPricingCard({ plan, period, setDialogOpen, isCompact }) {
  const price = period === 'annual' ? plan.priceAnnual : plan.priceMonthly;

  return (
    <View
      style={{
        flex: isCompact ? undefined : 1,
        width: isCompact ? '100%' : undefined,
        backgroundColor: theme.colors.surfaceCard,
        borderWidth: theme.borderWidth.thin,
        borderColor: plan.featured ? theme.colors.accentPrimary : theme.colors.borderDefault,
        borderRadius: theme.radii.lg,
        padding: isCompact ? 24 : 32,
      }}
    >
      {plan.featured && (
        <View
          style={{
            position: 'absolute', top: -13, left: 28,
            backgroundColor: theme.colors.accentPrimary,
            borderRadius: theme.radii.full, paddingVertical: 4, paddingHorizontal: 12,
          }}
        >
          <Text
            style={{
              fontFamily: theme.typography.fontMono, fontSize: theme.typography.size['2xs'],
              letterSpacing: theme.trackingPx(theme.typography.size['2xs'], 'widest'),
              textTransform: 'uppercase', color: theme.colors.accentOnPrimary,
            }}
          >
            Most popular
          </Text>
        </View>
      )}

      <View
        style={{
          alignSelf: 'flex-start',
          backgroundColor: plan.featured ? theme.colors.brandBlueTint : theme.colors.surfaceSunken,
          borderRadius: theme.radii.full, paddingVertical: 4, paddingHorizontal: 10, marginBottom: 16,
        }}
      >
        <Text
          style={{
            fontFamily: theme.typography.fontMono, fontSize: theme.typography.size['2xs'],
            letterSpacing: theme.trackingPx(theme.typography.size['2xs'], 'widest'),
            textTransform: 'uppercase',
            color: plan.featured ? theme.colors.accentPrimary : theme.colors.textSecondary,
          }}
        >
          {plan.tag}
        </Text>
      </View>

      <Text style={{ fontFamily: theme.typography.fontSans, fontWeight: theme.typography.weight.semibold, fontSize: theme.typography.size.md, marginBottom: 14 }}>
        {plan.title}
      </Text>

      <View style={{ flexDirection: 'row', alignItems: 'baseline', gap: 6, flexWrap: 'wrap' }}>
        <Text
          style={{
            fontFamily: theme.typography.fontDisplay,
            fontSize: isCompact ? theme.typography.size['3xl'] : theme.typography.size['4xl'],
            letterSpacing: theme.trackingPx(isCompact ? theme.typography.size['3xl'] : theme.typography.size['4xl'], 'tight'),
          }}
        >
          {price}
        </Text>
        <Text style={{ fontFamily: theme.typography.fontSans, fontSize: theme.typography.size.sm, color: theme.colors.textTertiary }}>/mo</Text>
      </View>
      <Text style={{ fontFamily: theme.typography.fontSans, fontSize: theme.typography.size.xs, color: theme.colors.textTertiary, marginTop: 4 }}>
        billed {period === 'annual' ? 'annually' : 'monthly'}
      </Text>

      <View style={{ marginTop: 20, marginBottom: 24 }}>
        <Button variant={plan.ctaVariant} size="md" onPress={() => setDialogOpen(true)} style={{ width: '100%' }}>
          Get More Info
        </Button>
      </View>

      {plan.rows.map(([label, value], i) => (
        <View
          key={label}
          style={{
            flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, paddingVertical: 11,
            borderBottomWidth: i === plan.rows.length - 1 ? 0 : theme.borderWidth.thin,
            borderBottomColor: theme.colors.borderSubtle,
          }}
        >
          <Text style={{ flex: 1, fontFamily: theme.typography.fontSans, fontSize: theme.typography.size.sm, color: theme.colors.textSecondary }}>{label}</Text>
          <Text style={{ flexShrink: 0, textAlign: 'right', fontFamily: theme.typography.fontMono, fontSize: theme.typography.size.sm, color: theme.colors.textPrimary }}>{value}</Text>
        </View>
      ))}
    </View>
  );
}
